import { render, staticRenderFns } from "./employee-details.vue?vue&type=template&id=e678385c&scoped=true&"
import script from "./employee-details.vue?vue&type=script&lang=js&"
export * from "./employee-details.vue?vue&type=script&lang=js&"
import style0 from "./employee-details.vue?vue&type=style&index=0&id=e678385c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e678385c",
  null
  
)

export default component.exports